import { render, staticRenderFns } from "./DataListTasks.vue?vue&type=template&id=6c33e782&scoped=true&"
import script from "./DataListTasks.vue?vue&type=script&lang=js&"
export * from "./DataListTasks.vue?vue&type=script&lang=js&"
import style0 from "./DataListTasks.vue?vue&type=style&index=0&id=6c33e782&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c33e782",
  null
  
)

export default component.exports